import { PaymentOptionsStoreState } from '@/interfaces/payment-options';
import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  state: {
    bankAccounts: {},
    cards: {},
    onboardingDetails: null,
    loading: false,
  } as PaymentOptionsStoreState,
  actions,
  getters,
  mutations,
};
